import { render } from "./BePartOfOurCommunityPage.vue?vue&type=template&id=fffe9c9c&scoped=true"
import script from "./BePartOfOurCommunityPage.vue?vue&type=script&lang=js"
export * from "./BePartOfOurCommunityPage.vue?vue&type=script&lang=js"

import "./BePartOfOurCommunityPage.vue?vue&type=style&index=0&id=fffe9c9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fffe9c9c"]])

export default __exports__